export const videoUrlValidator = (input: string) => {
  const regex = /https:\/\/www\.youtube|https:\/\/|www|youtube/;
  return regex.test(input);
};

export const threeDModelUrlValidator = (input: string) => {
  const regex = /https:\/\/.*scene\.splinecode/;
  return regex.test(input);
};
